"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _TextFieldBase = _interopRequireDefault(require("./TextFieldBase"));
var _Icon = _interopRequireDefault(require("../../Icons/Icon"));
var _style = require("../../../utils/style");
var _cls = _interopRequireDefault(require("@soluto-design/styles/cls"));
var _textFields = _interopRequireDefault(require("@soluto-design/styles/components/atoms/text-fields"));
var _excluded = ["id", "label", "disabled", "variant", "size", "error", "success", "help", "classes", "className", "htmlSize", "leftIcon", "leftIconButtonProps", "rightIcon", "rightIconButtonProps"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TextFieldSimple = /*#__PURE__*/(0, _react.forwardRef)(function TextFieldSimple(_ref, ref) {
  var id = _ref.id,
    label = _ref.label,
    disabled = _ref.disabled,
    variant = _ref.variant,
    size = _ref.size,
    error = _ref.error,
    success = _ref.success,
    help = _ref.help,
    classes = _ref.classes,
    className = _ref.className,
    htmlSize = _ref.htmlSize,
    leftIcon = _ref.leftIcon,
    leftIconButtonProps = _ref.leftIconButtonProps,
    rightIcon = _ref.rightIcon,
    rightIconButtonProps = _ref.rightIconButtonProps,
    props = _objectWithoutProperties(_ref, _excluded);
  var getIcon = (0, _react.useCallback)(function (position) {
    var icon = position === 'left' ? leftIcon : rightIcon;
    if (!icon) {
      return null;
    }
    var button = position === 'left' ? leftIconButtonProps : rightIconButtonProps;
    if (!button) {
      return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
        "data-position": position
      }, typeof icon === 'string' ? {
        icon: icon
      } : icon));
    }
    return /*#__PURE__*/_react["default"].createElement("button", _extends({
      type: "button"
    }, disabled && {
      disabled: disabled
    }, button, {
      "data-position": position
    }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], typeof icon === 'string' ? {
      icon: icon
    } : icon));
  }, [leftIcon, rightIcon, leftIconButtonProps, rightIconButtonProps, disabled]);
  return /*#__PURE__*/_react["default"].createElement(_TextFieldBase["default"], {
    id: id,
    label: label,
    disabled: disabled,
    variant: variant,
    size: size,
    error: error,
    success: success,
    help: help,
    classes: classes,
    className: className
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    ref: ref
  }, !!htmlSize && {
    size: htmlSize
  }, !!id && {
    id: id
  }, {
    className: (0, _cls["default"])(_textFields["default"].input, (0, _style.getStatusClassName)(classes === null || classes === void 0 ? void 0 : classes.input, success, error))
  }, !!leftIcon && {
    'data-left-icon': true
  }, !!rightIcon && {
    'data-right-icon': true
  }, !!disabled && {
    disabled: disabled
  }, props)), !!leftIcon && getIcon('left'), !!rightIcon && getIcon('right'));
});
var _default = exports["default"] = TextFieldSimple;
module.exports = exports.default;